export const obterAvaliacoesQuadrante = (
  avaliacoes,
  severidade,
  probabilidade,
  inerente
) => {
  const severidadeId = severidade.severidade?.id ?? severidade.id;
  const probabilidadeId = probabilidade.probabilidade?.id ?? probabilidade.id;

  return (avaliacoes || []).filter((avaliacao) => {
    const severidadeAtual = inerente
      ? avaliacao.severidadeInerente
      : avaliacao.severidade;
    const probabilidadeAtual = inerente
      ? avaliacao.probabilidadeInerente
      : avaliacao.probabilidade;
    return (
      severidadeAtual?.id != null &&
      probabilidadeAtual?.id != null &&
      severidadeAtual.id == severidadeId &&
      probabilidadeAtual.id == probabilidadeId
    );
  });
};

export const aplicarFiltroQuadrante = ({
  avaliacoes,
  riscoAvaliacoesOriginal,
  idsSelecionados,
  severidade,
  probabilidade,
  inerente,
  setFilter,
}) => {
  const ids = obterAvaliacoesQuadrante(
    riscoAvaliacoesOriginal ?? avaliacoes,
    severidade,
    probabilidade,
    inerente
  ).map(({ risco }) => risco.id);

  if (riscoAvaliacoesOriginal) {
    setFilter?.(ids, severidade, probabilidade, inerente);
    return;
  }

  const cancelar =
    idsSelecionados &&
    JSON.stringify([...idsSelecionados].sort()) ===
      JSON.stringify([...ids].sort());
  if (cancelar) {
    if (ids.length) setFilter?.([], {}, {});
  } else {
    setFilter?.(ids, severidade, probabilidade);
  }
};

export const quadranteContemSelecionados = (avaliacoes, idsSelecionados) =>
  !idsSelecionados?.length ||
  avaliacoes.some(({ risco }) => idsSelecionados.includes(risco.id));

export const obterCodigosItens = (avaliacoes) =>
  avaliacoes.map((avaliacao) => avaliacao.codigoItemImpactado).join(', ');

export const obterAvaliacoesGrau = (avaliacoes, quadrantes, inerente) =>
  quadrantes.flatMap(({ severidade, probabilidade }) =>
    obterAvaliacoesQuadrante(avaliacoes, severidade, probabilidade, inerente)
  );

export const obterPosicaoCelula = (indexLinha, indexColuna) =>
  indexLinha + '-' + indexColuna;

const obterRegiaoContigua = (chaves, inicio, visitadas) => {
  const [linhaInicio, colunaInicio] = inicio;
  const chave = chaves[linhaInicio][colunaInicio];
  const regiao = [];
  const pendentes = [inicio];
  visitadas.add(obterPosicaoCelula(linhaInicio, colunaInicio));

  while (pendentes.length) {
    const [indexLinha, indexColuna] = pendentes.pop();
    regiao.push([indexLinha, indexColuna]);
    [
      [indexLinha - 1, indexColuna],
      [indexLinha + 1, indexColuna],
      [indexLinha, indexColuna - 1],
      [indexLinha, indexColuna + 1],
    ].forEach(([linhaVizinha, colunaVizinha]) => {
      const posicao = obterPosicaoCelula(linhaVizinha, colunaVizinha);
      if (
        chaves[linhaVizinha]?.[colunaVizinha] !== chave ||
        visitadas.has(posicao)
      )
        return;
      visitadas.add(posicao);
      pendentes.push([linhaVizinha, colunaVizinha]);
    });
  }

  return regiao.sort(([l1, c1], [l2, c2]) => l1 - l2 || c1 - c2);
};

const obterCelulaCentral = (regiao) => {
  const mediaLinha =
    regiao.reduce((total, [indexLinha]) => total + indexLinha, 0) /
    regiao.length;
  const mediaColuna =
    regiao.reduce((total, [, indexColuna]) => total + indexColuna, 0) /
    regiao.length;
  const distancia = ([indexLinha, indexColuna]) =>
    (indexLinha - mediaLinha) ** 2 + (indexColuna - mediaColuna) ** 2;

  return regiao.reduce((central, celula) =>
    distancia(celula) < distancia(central) ? celula : central
  );
};

export const agruparCelulasPorGrau = (chaves) => {
  const graus = new Map();
  chaves.forEach((linha, indexLinha) =>
    linha.forEach((chave, indexColuna) => {
      if (chave == null) return;
      if (!graus.has(chave)) graus.set(chave, { celulas: [] });
      graus.get(chave).celulas.push([indexLinha, indexColuna]);
    })
  );

  const visitadas = new Set();
  graus.forEach((grau) => {
    let maiorRegiao = [];
    grau.celulas.forEach((celula) => {
      if (visitadas.has(obterPosicaoCelula(...celula))) return;
      const regiao = obterRegiaoContigua(chaves, celula, visitadas);
      if (regiao.length > maiorRegiao.length) maiorRegiao = regiao;
    });
    grau.posicaoTotalizador = obterPosicaoCelula(
      ...obterCelulaCentral(maiorRegiao)
    );
  });

  return graus;
};
